<template>
    <div class="representantes">
        <div class="representantes-title">
            <h1>Representantes</h1>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="repres-card">
                        <div class="repres-card-title">
                            <h1>{{ representanteSelected.estado }}</h1>
                        </div>
                        <div class="repres-card-content">
                            <ul>
                                <li v-for="(rs, index) in representanteSelected.lista" :key="index">
                                    <span> - {{ rs.nome }}</span>
                                    <p>{{ rs.descricao }}</p>
                                </li>
                                <!-- <pre>{{ representanteSelected }}</pre> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 representantes-mapa">
                    <div id="map" class="map"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jQuery from 'jquery'

require('jvectormap')
require('../../assets/brazil.js')
require('../../../node_modules/jvectormap/jquery-jvectormap.css')

let $ = jQuery

export default {
    data(){
        return {
            representantes: [
                {
                    id: 'BR-SP',
                    estado: 'São Paulo',
                    lista: [
                        {
                            nome: 'Representante X',
                            descricao: 'Localização do representante X.'
                        },
                        {
                            nome: 'Representante Y',
                            descricao: 'Localização do representante Y.'
                        },
                        {
                            nome: 'Representante Teste',
                            descricao: 'Localização do representante de Teste.'
                        }
                    ]
                },
                {
                    id: 'BR-PR',
                    estado: 'Paraná',
                    lista: [
                        {
                            nome: 'Representante Z',
                            descricao: 'Localização do representante Z'
                        },
                        {
                            nome: "Representante W",
                            descricao: 'localização do representante W'
                        }
                    ]
                },
                {
                    id: 'BR-RJ',
                    estado: 'Rio de Janeiro',
                    lista: [
                        {
                            nome: 'Representante A',
                            descricao: 'Localização do representante A.'
                        },
                        {
                            nome: 'Representante S',
                            descricao: 'Localização do representante S.'
                        },
                        {
                            nome: 'Representante Teste',
                            descricao: 'Localização do representante de Teste.'
                        },
                        {
                            nome: 'Representante Teste 2',
                            descricao: 'Localização do representante de Teste 2.'
                        }
                    ]
                }
            ],
            representanteSelected: [],
            teste: null
        }
    },
    mounted() {
        this.representanteSelected = this.representantes[0]
        this.drawMap(this.representantes)
    },
    methods: {
        drawMap: function(representantes){
            
            var vm = this;

            $('#map').vectorMap({
                map: 'brazil',
                zoomButtons: false,
                backgroundColor: '#f1f0f0',
                regionStyle: {
                    initial: {
                        fill: '#aeaeb3',
                        stroke: "black",
                        'stroke-width': 0.5,
                        opacity: 1,
                    },
                    hover: {
                        fill: '#5b5a5d',
                        cursor: 'pointer'
                    },
                    selected: {
                        fill: '#5b5a5d'
                    }
                },
                onRegionClick: function(event, code){
                    for(var i = 0; i <= representantes.length; i++){
                        if(code === representantes[i].id){
                            vm.representanteSelected = representantes[i]
                        } 
                    }
                }
            });
        }
    }
}
</script>

<style scoped>

.map {
    width: 100%; 
    height: 600px;
}

.representantes {
  text-transform: uppercase;
  background: #f1f0f0;
  width: 100%;
  height: 100vh;
}

.representantes-title h1 {
  padding: 20px;
  font-size: 14pt;
  padding-left: 6%;
  padding-top: 6%;
}

.representantes-mapa {
    text-align: center;
    width: 100%;
    height: 100%;
}

.repres-card {
    width: 100%;
    color: #fff;
    font-family: 'Bambino';
    margin-top: 140px;
}

.repres-card-title {
    background: #979ba4;
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.repres-card-title h1 {
    font-size: 10pt;
    font-weight: 300;
}

.repres-card-content {
    background: #b6b8bc;
    padding-top: 20px;
    padding-bottom: 60px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    list-style:  none;
    padding-right: 85px;
}

.repres-card-content ul {
    list-style:  none;
}
.repres-card-content ul>li {
    padding-bottom: 10px;
}
.repres-card-content p {
    font-weight: 300;
    font-size: 8pt;

}
.repres-card-content span {
    font-size: 9pt;
    font-weight: 400;
}

@media only screen and (min-width: 320px) and (max-width: 1024px) {

    .representantes {
        height:100%;
        /* display: flex;
        flex-direction: column;
        flex-grow: 1; */
    }

    .representantes-mapa img {
        width: 100%;
        margin-top: 40px;
        margin-bottom: 40px
    }

    .repres-card {
        margin-top: 10px;
    }
    
    .map {
        width: 80%; 
        height: 300px;
        text-align: center;
    }

}

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaRepresentantes.vue